import { yup } from '@framework/validation/initYup.ts';

const CyclicDependencyFieldNameRegex =
  /Cyclic dependency, node was:"([a-zA-Z0-9_-]+)"/;

/**
 * Gestisce l'errore di dipendenza ciclica nella generazione dello schema di validazione.
 */
export function manageCiclicDependencyError(e: Error): {
  schema: yup.ObjectSchema<yup.AnyObject, yup.AnyObject, any, ''>;
  errors?: string[];
} {
  const fieldName = e.message.match(CyclicDependencyFieldNameRegex)?.[1];
  // biome-ignore format: <tbd>
  console.error(`[FormValidatorBuilder] Dipendenza ciclica, impossibile costruire il validatore`, e);
  return {
    schema: yup.object().shape({}),
    errors: [
      `È presente una dipendenza ciclica tra gli elementi della sezione.${
        fieldName
          ? ` Il problema si è verificato nel campo con codice "${fieldName}".`
          : ''
      }`,
    ],
  };
}

export function isCiclicDependencyError(e: Error) {
  return e instanceof Error && e.message.startsWith('Cyclic dependency');
}
